import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { MapContainer, TileLayer } from "react-leaflet";
import { useLocation } from "react-router-dom";
import MapLayers from "./maplayers";
import GeoJsonHandler from "./Geojsonhandler";
import ImageOverlayDraw from "./imageoverlay";

const MapWithDraw = () => {
  const location = useLocation();
  const selectedLocation = location.state?.selectedLocation || { lat: 20.5937, lon: 78.9629 };

  return (
    <Container className="mt-4">
      <Row className="justify-content-center">
        <Col md={10}> {/* Increased width by changing md={8} to md={10} */}
          <Card className="shadow-lg p-4">
            <Card.Body>
              <Card.Title className="text-center mb-4">Map With Drawing Tools</Card.Title>
              <div className="border rounded overflow-hidden" style={{ height: "500px" }}>
                <MapContainer
                  center={[selectedLocation.lat, selectedLocation.lon]}
                  zoom={10}
                  style={{ height: "100%", width: "100%" }}
                >
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  <MapLayers />
                  <GeoJsonHandler />
                  <ImageOverlayDraw />
                </MapContainer>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default MapWithDraw;